import { HttpClient } from './httpClient'

export const calculateCheckDigit = (filerCode, entryNumber) => {
  let data = {
    eventType: 'CALCULATE_CHECK_DIGIT',
    eventTime: Date.now(),
    eventMessage: `${filerCode},${entryNumber}`
  }
  console.log('CALCULATE_CHECK_DIGIT', data)
  return HttpClient.post(data)
}

export const transformTransactionsForMerge = (data = {}) =>{
  const shipment = data?.transactionList?.map((transaction)=>({
    state:{
      shipmentId: transaction.transactionId,
      mbol: transaction?.mblList,
      hbol: transaction?.hblList,
      countryOfOrigin: transaction?.exportCountry,
      unlocUnlading: transaction?.portOfUnlading,
      carrierName: transaction?.vesselName,
      modeOfTransport: transaction?.modeOfTransport
    }
  }))
  return {
    shipment
  }
}